export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4419.047619047619,
    ],
    button_spin: [
      6000,
      1018.7755102040815,
    ],
    end_free_spin: [
      9000,
      5928.344671201813,
    ],
    free_bet_big_win: [
      16000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      19000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      23000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      25000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      28000,
      40002.1768707483,
    ],
    free_spin_music: [
      70000,
      40002.1768707483,
    ],
    free_spin_popup: [
      112000,
      5072.108843537421,
    ],
    free_spin_start: [
      119000,
      4009.795918367345,
    ],
    inside_buttons: [
      125000,
      235.10204081632935,
    ],
    main_ambient: [
      127000,
      65298.86621315194,
    ],
    main_music: [
      194000,
      107205.07936507936,
    ],
    mega_win: [
      303000,
      6546.575963718795,
    ],
    outside_buttons: [
      311000,
      365.7142857142617,
    ],
    reel_spin: [
      313000,
      1499.1383219954741,
    ],
    reel_stop_01: [
      316000,
      313.4693877551058,
    ],
    reel_stop_02: [
      318000,
      339.59183673471216,
    ],
    reel_stop_03: [
      320000,
      313.4693877551058,
    ],
    reel_stop_04: [
      322000,
      313.4693877551058,
    ],
    reel_stop_05: [
      324000,
      365.7142857142617,
    ],
    regular_win: [
      326000,
      2201.5419501133806,
    ],
    scatter_chance: [
      330000,
      4764.444444444451,
    ],
    tap_to_play: [
      336000,
      6148.934240362792,
    ],
    ultra_win: [
      344000,
      6352.108843537394,
    ],
  },
}
